import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'

export function isBouyguesOffer(offer: MobilePlanOffer) {
  return offer.partner.name === 'BOUYGUES_TELECOM'
}
